<footer class="no-print footer" [ngClass]="isExpand ? 'expand-footer' : 'collapse-footer'" >
    <div class="footer-text">
        &copy; <span translate>COMMON.ECOLAB_TEXT</span> {{ currentYear }}
    </div>
    <!-- <div>
        privacy policy and terms & conditions // need to do for this in future user stories
    </div> -->
    <img class="footer-img" src="./../../../../assets/images/menus/ecolab_logo.svg">
</footer>